import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/global.css'
// 去除按需加载代码
import './plugins/vant.js'
import 'vant/lib/icon/local.css'
import axios from 'axios'
import store from './store'
import wx from 'weixin-js-sdk'
import qs from 'qs'
import VueCookies from 'vue-cookies'
import global from './global.js'
import vPreviewImage from 'v-preview-image'
Vue.prototype.global = global
axios.defaults.baseURL = 'https://www.t-admin-api.jiaowushu.com/admin/'
Vue.use(vPreviewImage, { activeColor: 'pink' })
axios.interceptors.request.use(config => {
  config.headers.Authorization = 'Bearer  ' + window.sessionStorage.getItem('token')
  return config
})
axios.defaults.timeout = 50000
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.transformRequest = [obj => Qs.stringify(obj)]
Vue.prototype.$http = axios
Vue.prototype.$wx = wx
Vue.prototype.$cookies = VueCookies
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.prototype.$qs = qs
new Vue({
  router,
  store,
  wx,
  render: h => h(App)
}).$mount('#app')
